<template>
   <section class="jsk-block">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-4 col-md-4 col-sm-12 text-center">
            <p class="h3">{{ $t("courseDetails.schedule") }}</p>
            <p>{{ scheduleText }}</p>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-12 text-center">
            <p class="h3">{{ $t("courseDetails.location") }}</p>
            <p>{{ locationText }}</p>
          </div>
           <div class="col-12 col-lg-4 col-md-4 col-sm-12 text-center">
            <p class="h3">{{ $t("courseDetails.price") }}</p>
            <p>{{ priceText }}</p>
          </div>
        </div>
      </div>
    </section>
</template>


<script>
export default {
  name: "courseDetails",
  props: ["scheduleText", "locationText", "priceText"]
};
</script>